<template>
    <div class="stepper-input" @pointerdown.stop>
        <button class="icon min" type="button" @click="step(-1)" />
        <hr>
        <button class="icon plus" type="button" @click="step(1)" /> 
    </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class StepperInput extends Vue {
    /** Price in cents */
    @Prop({ default: 0 })
        min!: number | null

    /** Price in cents */
    @Prop({ default: null })
        max!: number | null

    valid = true;

    /** Price in cents */
    @Prop({ default: 0 })
        value!: number

    get internalValue() {
        return this.value
    }

    set internalValue(val: number) {
        this.$emit("input", val)
    }

    // Limit value to bounds
    constrain(value: number): number {
        if (this.min !== null && value < this.min) {
            value = this.min;
        } else if (this.max !== null && value > this.max) {
            value = this.max;
        }
        return value
    }

    step(add: number) {
        if (!this.valid) {
            return;
        }
        const v = this.constrain(this.internalValue + add);
        this.internalValue = v
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@use "~@stamhoofd/scss/base/variables.scss" as *;

.stepper-input {
    display: inline-flex;
    flex-direction: row;
    background: $color-background-shade;
    border-radius: $border-radius;
    align-items: stretch;
    height: $input-height;
    vertical-align: middle;
    contain: strict;
    width: 52px * 2 - $border-width; 

    hr {
        width: $border-width;
        flex-basis: $border-width;
        height: 19px;
        background: $color-gray-2;
        border-radius: calc($border-width / 2);
        border: 0;
        outline: 0;
        transition: opacity 0.2s;
        align-self: center;
        margin: 0;
        padding: 0;
        display: block;
    }

    &:active {
        hr {
            transition: none;
            opacity: 0;
        }
    }

    button {
        padding: 5px 14px;
        border-radius: $border-radius;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        transition: background-color 0.2s;
        touch-action: manipulation;
        user-select: none;
        cursor: pointer;
        outline: 0;
        display: block;

        &:active {
            background: $color-gray-3;
            transition: none;
        }

        &:last-child {
            margin-left: -$border-width;
        }

        &:first-child {
            margin-right: -$border-width;
        }
    }
}
</style>